// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3LUIk","signatureButtonsRight":"ModalSign_signatureButtonsRight__1nGVm"};